// frontend/src/constants/webhookEvents.ts
export interface WebhookEventOption {
  value: string;
  label: string;
  category: string;
}

export const WEBHOOK_EVENT_CATEGORIES = [
  'App',
  'Category',
  'Customer',
  'Order',
  'Product',
  'Domain',
] as const;

export const WEBHOOK_EVENTS: WebhookEventOption[] = [
  // App events
  { value: 'app/uninstalled', label: 'App desinstalada', category: 'App' },
  { value: 'app/suspended', label: 'App suspendida', category: 'App' },
  { value: 'app/resumed', label: 'App reactivada', category: 'App' },

  // Category events
  { value: 'category/created', label: 'Categoria creada', category: 'Category' },
  { value: 'category/updated', label: 'Categoria actualizada', category: 'Category' },
  { value: 'category/deleted', label: 'Categoria eliminada', category: 'Category' },

  // Customer events
  { value: 'customer/created', label: 'Cliente creado', category: 'Customer' },
  { value: 'customer/updated', label: 'Cliente actualizado', category: 'Customer' },
  { value: 'customer/deleted', label: 'Cliente eliminado', category: 'Customer' },

  // Order events
  { value: 'order/created', label: 'Orden creada', category: 'Order' },
  { value: 'order/updated', label: 'Orden actualizada', category: 'Order' },
  { value: 'order/paid', label: 'Orden pagada', category: 'Order' },
  { value: 'order/packed', label: 'Orden empaquetada', category: 'Order' },
  { value: 'order/fulfilled', label: 'Orden completada', category: 'Order' },
  { value: 'order/cancelled', label: 'Orden cancelada', category: 'Order' },

  // Product events
  { value: 'product/created', label: 'Producto creado', category: 'Product' },
  { value: 'product/updated', label: 'Producto actualizado', category: 'Product' },
  { value: 'product/deleted', label: 'Producto eliminado', category: 'Product' },

  // Domain events
  { value: 'domain/updated', label: 'Dominio actualizado', category: 'Domain' },
];

export const getEventLabel = (event: string): string => {
  const found = WEBHOOK_EVENTS.find((e) => e.value === event);
  return found?.label || event;
};

export const getEventsByCategory = (category: string): WebhookEventOption[] => {
  return WEBHOOK_EVENTS.filter((e) => e.category === category);
};
